<template>
  <div class="absolute w-full h-full z-20 flex items-justify " style="background: rgba(0,0,0, 0.4)">
    <div class="window dark shadow-lg rounded flex justify-center">
        <div class="window-content flex justify-center">
          <div class="tab-content visible" data-tab="0">
            <div class="row">
              <div class="label-col panel"><div class="label">Mode:</div></div>
              <div class="input-col panel">
                <select v-model="preferences.mode" style="width: 240px;min-height: 21px;">
                  <option value="cli">CLI</option>
                  <option value="http">HTTP</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="label-col panel"><div class="label">Theme:</div></div>
              <div class="input-col panel">
                <select v-model="preferences.theme" style="width: 240px;min-height: 21px;" id="themeOptions">
                  <option :key="t" :value="t" v-for="t in themes">
                    {{ t }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="label-col panel"><div class="label">Font Size:</div></div>
              <div class="input-col panel">
                <input type="number" class="form-control" step="1" style="max-width: 60px;" v-model="preferences.fontSize" />
              </div>
            </div>
            <div class="row">
              <div class="label-col panel"><div class="label">Line Height:</div></div>
              <div class="input-col panel">
                <input type="number" step="0.1" class="form-control" style="max-width: 60px;" v-model="preferences.lineHeight" />
              </div>
            </div>

            <div class="row" id="line-number-row">
              <div class="label-col panel">
                <div class="label">Show line numbers:</div>
              </div>
              <div class="input-col panel">
                <div class="checkbox">
                  <label>
                    <input v-model="preferences.lineNumbers" type="checkbox" id="always_show_line_numbers" />
                    <span style="visibility: hidden">-</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row" id="line-wrap-row">
              <div class="label-col panel"><div class="label">Line Wrap</div></div>
              <div class="input-col panel">
                <div class="checkbox">
                  <label>
                    <input v-model="preferences.lineWrapping" type="checkbox" id="wrap_line" />
                    <span style="visibility: hidden">-</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row pt-8 flex">
                <div class="flex-grow"></div>
                <a href="#" @click="closeSettings" class="self-end btn btn-default">Close</a>
            </div>

          </div>

        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Settings',
    data() {
      return {
        activeTab: 'General',
        fonts: [
          'Fira Code',
        ],
        themes: [
          'Dracula',
          'Material',
          'Github',
          'Solarized dark',
          'Solarized light',
        ],
        preferences: {
          mode: this.$store.state.Code.mode,
          fontSize: this.$store.state.Code.fontSize,
          lineHeight: this.$store.state.Code.lineHeight,
          autoEvaluate: this.$store.state.Code.autoEvaluate,
          lineNumbers: this.$store.state.Code.lineNumbers,
          lineWrapping: this.$store.state.Code.lineWrapping,
          theme: this.$store.state.Code.theme,
          font: this.$store.state.Code.font,
        }
      };
    },
    watch: {
      'preferences.mode'(value) {
        this.$store.dispatch("setPreference", {
          key: "mode",
          value,
        })
      },
      'preferences.fontSize'(value) {
        this.$store.dispatch("setPreference", {
          key: "fontSize",
          value,
        })
      },
      'preferences.lineHeight'(value) {
        this.$store.dispatch("setPreference", {
          key: "lineHeight",
          value,
        })
      },
      'preferences.autoEvaluate'(value) {
        this.$store.dispatch("setPreference", {
          key: "autoEvaluate",
          value,
        })
      },
      'preferences.lineNumbers'(value) {
        this.$store.dispatch("setPreference", {
          key: "lineNumbers",
          value,
        })
      },
      'preferences.lineWrapping'(value) {
        this.$store.dispatch("setPreference", {
          key: "lineWrapping",
          value,
        })
      },
      'preferences.theme'(value) {
        this.$store.dispatch("setPreference", {
          key: "theme",
          value,
        })
      },
      'preferences.font'(value) {
        this.$store.dispatch("setPreference", {
          key: "font",
          value,
        })
      },
    },
    methods: {
      closeSettings() {
        this.$parent.showSettings = false;
      },
    },
};
</script>

<style scoped>
.window {
    width: 500px;
    height: 360px;
    margin: 20px auto;
}
a {
  cursor: pointer;
}

@charset "UTF-8";
/*!
 * =====================================================
 * Photon v0.1.2
 * Copyright 2015 Connor Sears
 * Licensed under MIT (https://github.com/connors/proton/blob/master/LICENSE)
 *
 * v0.1.2 designed by @connors.
 * =====================================================
 */
audio,
canvas,
progress,
video {
  vertical-align: baseline; }

audio:not([controls]) {
  display: none; }

a:active,
a:hover {
  outline: 0; }

abbr[title] {
  border-bottom: 1px dotted; }

b,
strong {
  font-weight: bold; }

dfn {
  font-style: italic; }

h1 {
  font-size: 2em;
  margin: 0.67em 0; }

small {
  font-size: 80%; }

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline; }

sup {
  top: -0.5em; }

sub {
  bottom: -0.25em; }

pre {
  overflow: auto; }

code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em; }


input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  height: auto; }

input[type='search'] {
  -webkit-appearance: textfield;
  box-sizing: content-box; }

input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-decoration {
  -webkit-appearance: none; }

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em; }

legend {
  border: 0;
  padding: 0; }
  
hr {
  margin: 15px 0;
  overflow: hidden;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #ddd; }

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

h1 {
  font-size: 36px; }

h2 {
  font-size: 30px; }

h3 {
  font-size: 24px; }

h4 {
  font-size: 18px; }

h5 {
  font-size: 14px; }

h6 {
  font-size: 12px; }

.window-content {
  position: relative;
  overflow-y: auto;
  display: flex;
  flex: 1; }

.selectable-text {
  cursor: text;
  -webkit-user-select: text; }

.text-center {
  text-align: center; }

.text-right {
  text-align: right; }

.text-left {
  text-align: left; }

.pull-left {
  float: left; }

.pull-right {
  float: right; }

.padded {
  padding: 10px; }

.padded-less {
  padding: 5px; }

.padded-more {
  padding: 20px; }

.padded-vertically {
  padding-top: 10px;
  padding-bottom: 10px; }

.padded-vertically-less {
  padding-top: 5px;
  padding-bottom: 5px; }

.padded-vertically-more {
  padding-top: 20px;
  padding-bottom: 20px; }

.padded-horizontally {
  padding-right: 10px;
  padding-left: 10px; }

.padded-horizontally-less {
  padding-right: 5px;
  padding-left: 5px; }

.padded-horizontally-more {
  padding-right: 20px;
  padding-left: 20px; }

.padded-top {
  padding-top: 10px; }

.padded-top-less {
  padding-top: 5px; }

.padded-top-more {
  padding-top: 20px; }

.padded-bottom {
  padding-bottom: 10px; }

.padded-bottom-less {
  padding-bottom: 5px; }

.padded-bottom-more {
  padding-bottom: 20px; }

.sidebar {
  background-color: #f5f5f4; }

.draggable {
  -webkit-app-region: drag; }

.clearfix:before,
.clearfix:after {
  display: table;
  content: ' '; }

.clearfix:after {
  clear: both; }

.btn {
  display: inline-block;
  padding: 3px 8px;
  margin-bottom: 0;
  font-size: 13px;
  line-height: 1.4;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: default;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.06);
  -webkit-app-region: no-drag; }

.btn:focus {
  outline: none;
  box-shadow: none; }

.btn-mini {
  padding: 2px 6px; }

.btn-large {
  padding: 6px 12px; }

.btn-form {
  padding-right: 20px;
  padding-left: 20px; }

.btn-default {
  color: #333;
  border-top-color: #c2c0c2;
  border-right-color: #c2c0c2;
  border-bottom-color: #a19fa1;
  border-left-color: #c2c0c2;
  background-color: #fcfcfc;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fcfcfc), color-stop(100%, #f1f1f1));
  background-image: -webkit-linear-gradient(top, #fcfcfc 0%, #f1f1f1 100%);
  background-image: linear-gradient(to bottom, #fcfcfc 0%, #f1f1f1 100%); }

.btn-default:active {
  background-color: #ddd;
  background-image: none; }

.btn-primary,
.btn-positive,
.btn-negative,
.btn-warning {
  color: #fff;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1); }

.btn-primary {
  border-color: #388df8;
  border-bottom-color: #0866dc;
  background-color: #6eb4f7;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #6eb4f7), color-stop(100%, #1a82fb));
  background-image: -webkit-linear-gradient(top, #6eb4f7 0%, #1a82fb 100%);
  background-image: linear-gradient(to bottom, #6eb4f7 0%, #1a82fb 100%); }

.btn-primary:active {
  background-color: #3e9bf4;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #3e9bf4), color-stop(100%, #0469de));
  background-image: -webkit-linear-gradient(top, #3e9bf4 0%, #0469de 100%);
  background-image: linear-gradient(to bottom, #3e9bf4 0%, #0469de 100%); }

.btn-positive {
  border-color: #29a03b;
  border-bottom-color: #248b34;
  background-color: #5bd46d;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #5bd46d), color-stop(100%, #29a03b));
  background-image: -webkit-linear-gradient(top, #5bd46d 0%, #29a03b 100%);
  background-image: linear-gradient(to bottom, #5bd46d 0%, #29a03b 100%); }

.btn-positive:active {
  background-color: #34c84a;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #34c84a), color-stop(100%, #248b34));
  background-image: -webkit-linear-gradient(top, #34c84a 0%, #248b34 100%);
  background-image: linear-gradient(to bottom, #34c84a 0%, #248b34 100%); }

.btn-negative {
  border-color: #fb2f29;
  border-bottom-color: #fb1710;
  background-color: #fd918d;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fd918d), color-stop(100%, #fb2f29));
  background-image: -webkit-linear-gradient(top, #fd918d 0%, #fb2f29 100%);
  background-image: linear-gradient(to bottom, #fd918d 0%, #fb2f29 100%); }

.btn-negative:active {
  background-color: #fc605b;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fc605b), color-stop(100%, #fb1710));
  background-image: -webkit-linear-gradient(top, #fc605b 0%, #fb1710 100%);
  background-image: linear-gradient(to bottom, #fc605b 0%, #fb1710 100%); }

.btn-warning {
  border-color: #fcaa0e;
  border-bottom-color: #ee9d02;
  background-color: #fece72;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fece72), color-stop(100%, #fcaa0e));
  background-image: -webkit-linear-gradient(top, #fece72 0%, #fcaa0e 100%);
  background-image: linear-gradient(to bottom, #fece72 0%, #fcaa0e 100%); }

.btn-warning:active {
  background-color: #fdbc40;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fdbc40), color-stop(100%, #ee9d02));
  background-image: -webkit-linear-gradient(top, #fdbc40 0%, #ee9d02 100%);
  background-image: linear-gradient(to bottom, #fdbc40 0%, #ee9d02 100%); }

.btn .icon {
  float: left;
  width: 14px;
  height: 14px;
  margin-top: 1px;
  margin-bottom: 1px;
  color: #737475;
  font-size: 14px;
  line-height: 1; }

.btn .icon-text {
  margin-right: 5px; }

.btn-dropdown:after {
  font-family: 'photon-entypo';
  margin-left: 5px;
  content: ''; }

.btn-group {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  -webkit-app-region: no-drag; }

.btn-group .btn {
  position: relative;
  float: left; }

.btn-group .btn:focus,
.btn-group .btn:active {
  z-index: 2; }

.btn-group .btn.active {
  z-index: 3; }

.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group {
  margin-left: -1px; }

.btn-group > .btn:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.btn-group > .btn:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.btn-group > .btn:not(:first-child):not(:last-child) {
  border-radius: 0; }

.btn-group .btn + .btn {
  border-left: 1px solid #c2c0c2; }

.btn-group .btn + .btn.active {
  border-left: 0; }

.btn-group .active {
  color: #fff;
  border: 1px solid transparent;
  background-color: #6d6c6d;
  background-image: none; }

.btn-group .active .icon {
  color: #fff; }

.toolbar {
  min-height: 22px;
  box-shadow: inset 0 1px 0 #f5f4f5;
  background-color: #e8e6e8;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #e8e6e8), color-stop(100%, #d1cfd1));
  background-image: -webkit-linear-gradient(top, #e8e6e8 0%, #d1cfd1 100%);
  background-image: linear-gradient(to bottom, #e8e6e8 0%, #d1cfd1 100%); }

.toolbar:before,
.toolbar:after {
  display: table;
  content: ' '; }

.toolbar:after {
  clear: both; }

.toolbar-header {
  border-bottom: 1px solid #c2c0c2; }

.toolbar-header .title {
  margin-top: 1px; }

.toolbar-footer {
  border-top: 1px solid #c2c0c2;
  -webkit-app-region: drag; }

.title {
  margin: 0;
  font-size: 12px;
  text-align: center;
  color: #555;
  cursor: default; }

.toolbar-borderless {
  border-top: 0;
  border-bottom: 0; }

.toolbar-actions {
  margin-top: 4px;
  margin-bottom: 3px;
  padding-right: 3px;
  padding-left: 3px;
  padding-bottom: 3px;
  -webkit-app-region: drag; }

.toolbar-actions:before,
.toolbar-actions:after {
  display: table;
  content: ' '; }

.toolbar-actions:after {
  clear: both; }

.toolbar-actions > .btn,
.toolbar-actions > .btn-group {
  margin-left: 4px;
  margin-right: 4px; }

label {
  display: inline-block;
  font-size: 13px;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

input[type='search'] {
  box-sizing: border-box; }

input[type='radio'],
input[type='checkbox'] {
  margin: 4px 0 0;
  line-height: normal; }

.form-control {
  display: inline-block;
  color: white;
  width: 100%;
  min-height: 25px;
  padding: 5px 10px;
  font-size: 13px;
  line-height: 1.6;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: none; 
}

.form-control:focus {
  border-color: #6db3fd;
  box-shadow: 3px 3px 0 #6db3fd, -3px -3px 0 #6db3fd, -3px 3px 0 #6db3fd, 3px -3px 0 #6db3fd; }


.form-group {
  margin-bottom: 10px; }

.radio,
.checkbox {
  position: relative;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px; }

.radio label,
.checkbox label {
  padding-left: 20px;
  margin-bottom: 0; }

.radio input[type='radio'],
.radio-inline input[type='radio'],
.checkbox input[type='checkbox'],
.checkbox-inline input[type='checkbox'] {
  position: absolute;
  margin-left: -20px;
  margin-top: 4px; }

.form-actions .btn {
  margin-right: 10px; }

.form-actions .btn:last-child {
  margin-right: 0; }

.pane-group {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex; }

.pane {
  position: relative;
  overflow-y: auto;
  flex: 1;
  border-left: 1px solid #ddd; }

.pane:first-child {
  border-left: 0; }

.pane-sm {
  max-width: 220px;
  min-width: 150px; }

.pane-mini {
  width: 80px;
  flex: none; }

.pane-one-fourth {
  width: 25%;
  flex: none; }

.pane-one-third {
  width: 33.3%; }

img {
  -webkit-user-drag: text; }

.img-circle {
  border-radius: 50%; }

.img-rounded {
  border-radius: 4px; }

.list-group {
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0; }

.list-group * {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.list-group-item {
  padding: 10px;
  font-size: 12px;
  color: #414142;
  border-top: 1px solid #ddd; }

.list-group-item:first-child {
  border-top: 0; }

.list-group-item.active,
.list-group-item.selected {
  color: #fff;
  background-color: #116cd6; }

.list-group-header {
  padding: 10px; }

.media-object {
  margin-top: 3px; }

.media-object.pull-left {
  margin-right: 10px; }

.media-object.pull-right {
  margin-left: 10px; }

.media-body {
  overflow: hidden; }

.nav-group {
  font-size: 14px; }

.nav-group-item {
  padding: 2px 10px 2px 25px;
  display: block;
  color: #333;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.nav-group-item:active,
.nav-group-item.active {
  background-color: #dcdfe1; }

.nav-group-item .icon {
  width: 19px;
  height: 18px;
  float: left;
  color: #737475;
  margin-top: -3px;
  margin-right: 7px;
  font-size: 18px;
  text-align: center; }

.nav-group-title {
  margin: 0;
  padding: 10px 10px 2px;
  font-size: 12px;
  font-weight: 500;
  color: #666666; }

table {
  width: 100%;
  border: 0;
  border-collapse: separate;
  font-size: 12px;
  text-align: left; }

thead {
  background-color: #f5f5f4; }

tbody {
  background-color: #fff; }

.table-striped tr:nth-child(even) {
  background-color: #f5f5f4; }

thead tr:active {
  color: #333;
  background-color: #f5f5f4; }

th {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd; }

th,
td {
  padding: 2px 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

th:last-child,
td:last-child {
  border-right: 0; }

.tab-group {
  margin-top: -1px;
  display: flex;
  border-top: 1px solid #989698;
  border-bottom: 1px solid #989698; }

.tab-item {
  position: relative;
  flex: 1;
  padding: 3px;
  font-size: 12px;
  text-align: center;
  border-left: 1px solid #989698;
  background-color: #b8b6b8;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #b8b6b8), color-stop(100%, #b0aeb0));
  background-image: -webkit-linear-gradient(top, #b8b6b8 0%, #b0aeb0 100%);
  background-image: linear-gradient(to bottom, #b8b6b8 0%, #b0aeb0 100%); }

.tab-item:first-child {
  border-left: 0; }

.tab-item.active {
  background-color: #d4d2d4;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #d4d2d4), color-stop(100%, #cccacc));
  background-image: -webkit-linear-gradient(top, #d4d2d4 0%, #cccacc 100%);
  background-image: linear-gradient(to bottom, #d4d2d4 0%, #cccacc 100%); }

.tab-item .icon-close-tab {
  position: absolute;
  top: 50%;
  left: 5px;
  width: 15px;
  height: 15px;
  font-size: 15px;
  line-height: 15px;
  text-align: center;
  color: #666;
  opacity: 0;
  transition: opacity 0.1s linear, background-color 0.1s linear;
  border-radius: 3px;
  transform: translateY(-50%);
  z-index: 10; }

.tab-item:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: '';
  background-color: rgba(0, 0, 0, 0.08);
  opacity: 0;
  transition: opacity 0.1s linear;
  z-index: 1; }

.tab-item:hover:not(.active):after {
  opacity: 1; }

.tab-item:hover .icon-close-tab {
  opacity: 1; }

.tab-item .icon-close-tab:hover {
  background-color: rgba(0, 0, 0, 0.08); }

.tab-item-fixed {
  flex: none;
  padding: 3px 10px; }

.dark .form-control {
  background-color: #262627;
  border-color: #4B4945; }

.dark thead {
  background-color: #2D2D2D; }

.dark tbody {
  background-color: #1E1E1E; }

.dark .table-striped tr:nth-child(even) {
  background-color: #292929; }

.dark th {
  border-right: 1px solid #424242;
  border-bottom: 1px solid #424242; }

.dark .btn-default {
  color: #f9f9f9;
  border-top-color: #787878;
  border-right-color: transparent;
  border-left-color: transparent;
  border-bottom-color: #646464;
  background-color: #696969;
  background-image: linear-gradient(to bottom, #696969 0%, #646464 100%);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.06); }

.dark .btn-default.active {
  border-top-color: #d2d2d2;
  border-bottom-color: #c2c2c2;
  background-color: #c7c7c7;
  background-image: linear-gradient(to bottom, #c7c7c7 0%, #c2c2c2 100%);
  color: #3a3a3a; }

.dark .btn-default:active {
  border-top-color: #909090;
  border-bottom-color: #7e7e7e;
  background-color: #838383;
  background-image: linear-gradient(to bottom, #838383 0%, #7e7e7e 100%);
  color: #fafafa; }

.dark .btn-group .btn + .btn {
  border-left: 1px solid #585858; }
  .dark .btn-group .btn + .btn.active {
    border-left-color: transparent; }
  .dark .btn-group .btn + .btn:active {
    border-left-color: transparent; }

html {
  font-size: 14px;
  tab-size: 4;
  -webkit-font-smoothing: antialiased; }

[data-tab] {
  display: none; }

[data-active='0'] [data-tab='0'],
[data-active='1'] [data-tab='1'],
[data-active='2'] [data-tab='2'],
[data-active='3'] [data-tab='3'] {
  display: block; }

.window-content {
  background: #ececec;
  flex-direction: column;
  padding: 16px; }

body {
  background: #ececec;
  height: 100%; }

.dark {
  color: #e1e1e1;
  background: #323232; }
  .dark .window-content {
    background: #323232; }
  .dark .label-col {
    border-right: 1px solid #464646; }
  .dark select {
    color: #333333; }
  .dark #npm_list:empty:after {
    background-color: #1E1E1E; }
  .dark #npm_not_available {
    background: #323232; }
  .dark .toolbar {
    background-color: #414141;
    background-image: linear-gradient(to bottom, #414141 0%, #363636 100%);
    box-shadow: inset 0 1px 0 #131313; }
  .dark .toolbar-header {
    border-bottom: 1px solid #151515; }
  .dark .title {
    color: #bcbcbc; }

.toolbar {
  -webkit-app-region: drag; }

.toolbar .btn {
  min-width: 100px; }

.label-col {
  max-width: 170px;
  min-width: 170px;
  border-right: 1px solid #ddd; }

.row {
  display: -webkit-flex;
  display: flex; }

.row .panel {
  padding: 16px;
  -webkit-flex: 1;
  flex: 1;
  padding-bottom: 2px;
  padding-top: 8px; }

.row .label-col {
  padding-left: 8px;
  text-align: right; }

.row .input-col {
  max-width: 350px;
  position: relative; }

.row:first-child .panel {
  padding-top: 0; }

.row:last-child .panel {
  padding-bottom: 0; }

.tab-content {
  width: 100%; }

.radio {
  position: relative;
  display: inline-block; }

.radio,
.checkbox {
  margin-top: 0;
  margin-bottom: 0; }

.radio:first-child {
  position: relative;
  display: inline-block; }

.title {
  font-size: 13px; }

.hint {
  font-size: 12px;
  color: #656795;
  line-height: 14px; }

a.hint {
  text-decoration: none;
  cursor: pointer; }

label {
  white-space: normal; }

.checkbox ~ .checkbox {
  margin-top: 4px; }

.npm-table-wrapper {
  max-height: 235px;
  min-height: 60px;
  overflow: auto;
  width: 100%; }

.npm-table {
  text-align: center; }
  .npm-table td:first-child {
    text-align: left; }

.npm-name-col {
  width: 60%;
  text-align: left; }

.full-width {
  width: 100%; }

.search-results {
  max-height: 243px;
  overflow: auto;
  position: absolute;
  width: 100%;
  background-color: #ececec; }

.cap {
  text-transform: capitalize; }

#npm_list:empty:after {
  content: 'Nothing here...';
  text-align: center;
  font-style: italic;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 4px 0; }

.loading:after {
  content: '';
  position: absolute;
  right: 12px;
  top: 7px;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  border-top: 2px solid rgba(190, 190, 190, 0.2);
  border-right: 2px solid rgba(190, 190, 190, 0.2);
  border-bottom: 2px solid rgba(190, 190, 190, 0.2);
  border-left: 2px solid #bebebe;
  transform: translateZ(0);
  animation: spin 1.1s infinite linear; }

.btn {
  position: relative;
  min-width: 70px; }
  .btn.loading {
    text-indent: -9999px;
    overflow: hidden; }
    .btn.loading:after {
      top: 2px;
      right: 0;
      left: 0;
      margin: auto;
      width: 14px;
      height: 14px; }

.relative {
  position: relative; }

@keyframes spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

#npm_not_available {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #ececec;
  z-index: 1;
  display: none;
  top: 22px; }
  #npm_not_available p {
    margin-top: 50px; }

.visible {
  display: block !important; }

.nondarwin .hide-nodarwin {
  display: none; }

.nondarwin .toolbar {
  background: #ececec;
  border-bottom: 0 none; }
  .nondarwin .toolbar .title {
    display: none; }

.screenshot {
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 5px 15px 10px rgba(0, 0, 0, 0.2); }

.background-color-input-label {
  border-radius: 4px;
  border: 1px solid white;
  width: 30px;
  height: 30px;
  cursor: pointer;
  overflow: visible;
  text-indent: -43px;
  margin: 0 12px 0 84px;
  position: relative; }
  .background-color-input-label input {
    visibility: hidden;
    position: absolute;
    right: 0;
    width: 100%;
    height: 100%; }
  .background-color-input-label span {
    display: inline-block;
    margin-top: 3px; }

.screenshot-canvas {
  width: 818px;
  height: 500px; }

.canvas-wrapper {
  position: relative; }
  .canvas-wrapper.loading:after {
    margin: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100px;
    height: 100px;
    box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.1);
    border-width: 6px; }

.screenshot-controls {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px; }

.left-screenshot-controls {
  display: flex;
  flex-direction: row;
  align-items: center; }

.btn.refresh-btn {
  min-width: 35px;
  padding: 5px 7px 0 7px;
  margin-left: 14px; }

.screenshot-font-size {
  margin: 0 6px 2px 0; }


</style>
